module.exports = __webpack_public_path__ + "assets/img/kid_register_without_panda.dbcc16c9.png";